import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const LANGUAGES_API = "/studies/languages/";

export const getLanguages = (params) => {
  return axios.get(LANGUAGES_API, {params: params}).then(res => res.data.data);
}

export const addLanguage = (name) => {
  let payload = {
    name
  }
  return axios.post(LANGUAGES_API, payload, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res.data);
}

export const updateLanguage = (id, body) => {
  return axios.put(`${LANGUAGES_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res.data);
}

export const deleteLanguage = (id) => {
  return axios.delete(`${LANGUAGES_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => res);
}
